import React, { useState } from 'react';
import './Siliconeinje.css';
import Silicones1 from '../../../imgs/Silicones1.webp';
import Silicones2 from '../../../imgs/Silicones2.webp';
import Silicones3 from '../../../imgs/Silicones3.webp';
import Silicones4 from '../../../imgs/Silicones4.webp';
import Reqprodcte from "../../../components/Reqprodcte";

const images = [
    { src: Silicones1 },
    { src: Silicones2 },
    { src: Silicones3 },
    { src: Silicones4 },
];

const Siliconeinje = () => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((current + 1) % images.length);
    };

    const prevSlide = () => {
        setCurrent((current - 1 + images.length) % images.length);
    };

    const goToSlide = (index) => {
        setCurrent(index);
    };

    return (
        <div className="Silicon-main-container" data-aos="fade-down">

            <div className="Silicon-slideshow">
                {images.map((img, index) => (
                    <div className={index === current ? "mySlides active" : "mySlides"} key={index}>
                        {index === current && (
                            <>
                                <img src={img.src} alt={`Slide ${index + 1}`} className="slide-image" />
                            </>
                        )}
                    </div>
                ))}
                <a className="prev" onClick={prevSlide}>&#10094;</a>
                <a className="next" onClick={nextSlide}>&#10095;</a>

                <div className="dots">
                    {images.map((_, index) => (
                        <span
                            key={index}
                            className={index === current ? "dot active" : "dot"}
                            onClick={() => goToSlide(index)}
                        ></span>
                    ))}
                </div>
            </div>

            <div className="Silicon-text">
                <h2>Silicone Injection Molding Machine</h2>
                <h3>SI SERIES</h3>
                <p>
                    Powerjet SI Series silicone injection molding machine is suitable for baby supplies, medical, adult, automobile accessories, electronic accessories, stationery, such as diving equipment liquid silicone products. </p>
                <ul>
                    <li><strong>Clamping Force:</strong> –  90~200(Ton)</li>
                    <li><strong>Shot Weight(PS):</strong> – 153~489(g)</li>

                    <li><strong>Injection Speed :</strong>- 1.5~1.8(S)</li>
                </ul>
                <div className='stnd'>
                    <Reqprodcte />
                </div>                </div>
        </div>
    );
};
export default Siliconeinje;
